import { Error } from "@progress/kendo-react-labels";
import { MaskedTextBox } from "@progress/kendo-react-inputs";
import { utility } from "../../../utility/utilityProvider";
import { useEffect, useRef } from "react";
//timepicker component with format
export const TimeRangePicker = (fieldRenderProps) => {
  const { validationMessage, visited, disabled = false, ...others } = fieldRenderProps;
  const defaultValue = fieldRenderProps.mask ?? '00:00';
  const inputRef = useRef();

  useEffect(() => {
    const handleCopy = (e) => {
      if (inputRef.current && inputRef.current.contains(e.target)) {
        // Allow copy, but block parent's copy listeners
        e.stopImmediatePropagation();
      }
    };

    document.addEventListener("copy", handleCopy, true); // capture phase

    return () => {
      document.removeEventListener("copy", handleCopy, true);
    };
  }, []);
  return (
    <div ref={inputRef}>
      <MaskedTextBox
        {...others}
        disabled={disabled}
        mask="00:00"
        defaultValue="00:00"
        value={fieldRenderProps.value ? utility.validateShortTimeString(fieldRenderProps.value) : defaultValue}
        style={{
          backgroundColor: disabled ? "#e9ecef" : "white",
          ...(others.style || {})
        }}
      />
      {/* {visited && validationMessage && <Error>{validationMessage}</Error>} */}
    </div>
  );
};